import type { OperationVariables } from '@apollo/client'

import type {
  HighFrequency_OrderStatus,
  HighFrequencyOrdersQuery,
} from '#api/shared/@types/generated/backend/graphql-schema-types'

type Parameters = {
  limit: number
  status: HighFrequency_OrderStatus[]
  licensedTerritory: string
}

type UpdateQueryOptions = {
  fetchMoreResult?: HighFrequencyOrdersQuery
  variables?: OperationVariables
}

const updateQuery = (
  previousResult: HighFrequencyOrdersQuery,
  { fetchMoreResult, variables }: UpdateQueryOptions,
): HighFrequencyOrdersQuery => {
  if (!fetchMoreResult || isGraphqlFailure(fetchMoreResult?.highFrequencyOrders)) {
    return previousResult
  }
  const { count, highFrequencyOrders } = fetchMoreResult.highFrequencyOrders

  if (!variables?.offset) {
    return fetchMoreResult
  }

  const enrichedOrders = {
    highFrequencyOrders: {
      ...previousResult.highFrequencyOrders,
      count,
      highFrequencyOrders: [
        ...(isGraphqlSuccess(previousResult?.highFrequencyOrders)
          ? previousResult.highFrequencyOrders.highFrequencyOrders
          : []),
        ...highFrequencyOrders,
      ],
    },
  }
  return enrichedOrders
}

export const useHighFrequencyOrders = ({ limit, status, licensedTerritory }: Parameters) =>
  useFetchMoreWrapper(
    () =>
      useHighFrequencyOrdersQuery(
        {
          filter: {
            highFrequencyGames: [],
            status,
          },
          licensedTerritory,
          limit,
          offset: 0,
        },
        { fetchPolicy: 'network-only' },
      ),
    updateQuery,
    (result) => {
      if (isGraphqlSuccess(result?.highFrequencyOrders)) {
        return result?.highFrequencyOrders.highFrequencyOrders.length
      }
    },
    (result) => {
      if (isGraphqlSuccess(result?.highFrequencyOrders)) {
        return result?.highFrequencyOrders.count
      }
    },
    'myorders.detail.playslip.error',
    (result) => {
      if (isGraphqlFailure(result?.highFrequencyOrders)) {
        return result?.highFrequencyOrders.errors
      }
      return undefined
    },
  )
